import React, { useContext, useEffect } from 'react'
import get from 'lodash.get'
import cx from 'classnames'
import PropTypes from 'prop-types'

import { ThemeContext } from '@cred/react-theme'

import WidgetContext from 'components/widget-context'

import styles from './styles.module.scss'

const SUPPORTED_THEMES = ['nypost', 'fox', 'fox1', 'forbes', 'forbes1', 'insider']
const SUPPORTED_WIDGETS = {
  'mortgage-combined': {
    'rate-table': ['shortened', 'simple', 'interactive'],
    'rate-tracking': ['simple'],
    'rich-cta': ['interactive', 'copy-only'],
  },
  'mortgage-refi': {
    'rich-cta': ['copy-only'],
    'simple-cta': ['all'],
  },
  mortgage: {
    'simple-cta': ['all'],
    'rich-cta': ['copy-only'],
  },
}

const checkIfShouldShowPaidAdvertisement = (product, theme) => {
  const { marketplace, type, variation } = product
  const widgetTypeVariations = get(SUPPORTED_WIDGETS, [marketplace, type])

  return !!(
    widgetTypeVariations &&
    (widgetTypeVariations.includes(variation) || widgetTypeVariations.includes('all')) &&
    SUPPORTED_THEMES.includes(theme)
  )
}

const PaidAdvertisement = ({ className, display }) => {
  const theme = useContext(ThemeContext)
  const {
    options: { product },
  } = useContext(WidgetContext)

  const shouldShowPaidAdvertisementText =
    display || checkIfShouldShowPaidAdvertisement(product, theme)

  useEffect(() => {
    if (shouldShowPaidAdvertisementText) {
      window.requestAnimationFrame(() => {
        // Send postmessage to SDK so it can adjust box shadow around the widget
        window.parent.postMessage('advertiserDisclosure', '*')
        console.info('[Info] - Dispatch "advertiserDisclosure" postMessage')
      })
    }
  }, [shouldShowPaidAdvertisementText])

  if (!shouldShowPaidAdvertisementText) return null

  return (
    <p className={cx(styles.paidAdvertisement, className, 'disclaimer', 'neutral500')}>
      Paid Advertisement
    </p>
  )
}

PaidAdvertisement.propTypes = {
  className: PropTypes.string,
  display: PropTypes.bool,
}

export default PaidAdvertisement
